import { createContext, createElement, useContext, useReducer } from 'react';
import type { Mutation } from './mutations';
import type { State } from './types';
import { reducer } from './mutations';

export interface RemindersStore {
  state: State;
  dispatch: React.Dispatch<Mutation>;
}

const initialState: State = {
  list: [],
  loaded: false,
};

export const RemindersContext = createContext<RemindersStore>({
  state: initialState,
} as RemindersStore);

export function RemindersStoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return createElement(
    RemindersContext.Provider,
    { value: { state, dispatch } },
    children,
  );
}

export function useRemindersStore() {
  return useContext(RemindersContext);
}
